const locales = {
  chat_usersConnected: 'Mostrar solo conectados',
  chat_newChat: "Nuevo chat",
  search_user: "Buscar por conductor, usuario…",
  user_filter: "Filtrar",
  online_only: "Solo en línea",
  show_users: "Mostrar usuarios",
  show_drivers: "Mostrar conductores",
  empty_text: "Aún no hay nada para mostrar.",
  chat_lastMessage: "Último mensaje",
  MASTERUSER: 'Usuario administrador',
  SUBUSER: 'Usuario',
  DRIVER: 'Conductor',
  chat_onlineStatus: "Conectado",
  chat_offlineStatus: "Desconectado",
  chat_writingStatus: "Escribiendo…",
  chat_messageStatus: "Leído",
  chat_modalTitle: "Chats",

  ai_title: 'Neurion AI (BETA)',
  ai_defaultMessage: "¡Hola! ¿Cómo puedo ayudarte?",
  agent_question_placeholder: 'Pregúntame sobre la plataforma GPS Trackit…',
  agent_send: 'Enviar',
  agent_thinking: 'Buscando en la base de conocimientos de GPS Trackit…',
  agent_sending: 'Buscando...',
  agent_error: 'Ocurrió un error. Intenta nuevamente.',
  agent_welcome: '¡Hola! Soy tu asistente de IA. ¿Cómo puedo ayudarte con la gestión de tu flota hoy?',
  agent_response_template: 'Para tu pregunta: "{question}", así puedes hacerlo. Esto requiere varios pasos en el panel de configuración.',
  agent_action_show_how: '¿Quieres que te muestre cómo hacerlo?',
  agent_action_show_where: '¿Quieres que te muestre dónde está?',
  header_agentIcon: 'zonAI',
  header_agentIconAriaLabel: 'Abrir asistente zonAI',

  support_title: "Habla con Soporte",
  support_chat_title: "Chat de soporte",
  support_defaultMessage: "Iniciar un nuevo chat de soporte",

  // Support Chat - Connection Status
  support_status_offline: "Desconectado",
  support_status_initializing: "Inicializando...",
  support_status_connecting: "Conectando con soporte...",
  support_status_waiting_agent: "Buscando un agente disponible...",
  support_status_connected: "Conectado",
  support_status_reconnecting: "Reconectando...",
  support_status_agent_unavailable: "No hay agentes disponibles en este momento",
  support_status_ended: "Conversación finalizada",
  support_status_error: "Error de conexión",

  // Support Chat - Input Placeholders
  support_input_initializing: "Inicializando...",
  support_input_connecting: "Conectando con soporte...",
  support_input_waiting: "Esperando que un agente se una...",
  support_input_unavailable: "No hay agentes disponibles en este momento",
  support_input_ended: "La conversación ha finalizado",
  support_input_error: "Error de conexión — chat no disponible",
  support_input_unavailable_default: "Chat no disponible",

  // Support Chat - Wait Screen
  support_wait_message: "Estamos buscando a la mejor persona para ayudarte. Estaremos contigo en breve.",
  support_wait_finishing_title: "Encontrando a la mejor persona para ayudarte",
  support_wait_finishing_message: "Te estamos conectando con el agente adecuado para tu solicitud. Esto suele tomar solo un momento — ¡gracias por tu paciencia!",
  support_cancel_request: "Cancelar solicitud",
  support_unavailable_title: "Nuestros agentes están finalizando otros chats",
  support_unavailable_message_before: "Está tardando un poco más de lo habitual. Puedes seguir esperando aquí o ",
  support_unavailable_message_after: " — te responderemos tan pronto como alguien esté disponible.",
  support_unavailable_email_link: "enviarnos un correo electrónico",
  support_no_agents_title: "No pudimos conectarte en este momento",
  support_no_agents_message_before: "No encontramos un agente disponible en este momento. Sin embargo, puedes ",
  support_no_agents_message_after: " y te responderemos tan pronto como sea posible.",
  support_start_new_chat: "Iniciar un nuevo chat de soporte",
  support_agent_default_name: "Agente de soporte",
  support_started_message: "de Zonar se ha unido al chat",
  support_ended_message_before: "de Zonar ha salido del chat",
  support_ended_message: "La conversación ha finalizado. Cierra y vuelve a abrir el chat para iniciar una nueva conversación.",
  support_agent_typing: "El agente de soporte está escribiendo…",
  support_network_error: "Problema de conexión de red - Por favor, inténtalo de nuevo más tarde",

  last_day: "Último",
  message_Sent: "Enviado",
  message_Read: "Leído",
  chat_startNewConversation: "Iniciar una nueva conversación",
  chat_startedAt: "Chat iniciado a las",
  chat_startedOn: "Chat iniciado el",

  // AI Welcome Message
  ai_welcome_greeting: `¡Hola! Soy **Neurion** 👋`,
  ai_welcome_description: `Estoy aquí para ayudarte a sacar el máximo provecho de nuestra plataforma. Puedes preguntarme cómo usar las funciones, dónde encontrar cosas o pedir recomendaciones y buenas prácticas.`,
  ai_welcome_cta: `¿En qué puedo ayudarte hoy?`,

  agent_stage_IDLE: `Inactivo`,
  agent_stage_ANALYZING: `Analizando tu solicitud…`,
  agent_stage_CONNECTING_KB_AGENT: `Conectando al agente de la base de conocimiento...`,
  agent_stage_RETRIEVING: `Buscando información relevante…`,
  agent_stage_GENERATING: `Generando respuesta…`,
  agent_stage_COMPLETE: `Completado`,
  agent_stage_ERROR: `Algo salió mal — por favor, intenta nuevamente en breve.`,
  agent_stage_RATE_LIMIT_EXCEEDED: `Has alcanzado el límite diario de mensajes. Comunícate con el servicio al cliente para ampliar los límites de tu plan.`,
  agent_stage_try_again: `Intentar de nuevo`,
  agent_stage_INPUT_VALIDATION_ERROR: `Tuvimos un problema técnico y no pudimos procesar tu solicitud. Ponte en contacto con el equipo de soporte para obtener ayuda.`,
  agent_stage_SCHEMA_VALIDATION_ERROR: `Tuvimos un problema técnico y no pudimos procesar tu solicitud. Ponte en contacto con el equipo de soporte para obtener ayuda.`,

  // AI Connection Status
  ai_status_connecting: "Conectando...",
  ai_status_connection_lost: "Conexión perdida...",

  // AI Suggestions
  ai_suggestions_intro: "¡Hola! ¿Cómo puedo ayudarte? Estas son algunas de las preguntas más comunes con las que puedo asistirte:",
};

export default locales;
